var userIdToDelete;
jQuery(document).ready(function ($) {
	// Handle the initial click on the delete icon
	$(document).on('click', '.ccare__delete-user-btn', function() {
		userIdToDelete = $(this).data('user-id');
	});

	// Handle the confirmation (delete operation)
	$('.ccare__confirm-delete-user-btn').click(function() {
		if (userIdToDelete) {
			$.ajax({
				type: 'POST',
				url: wpData.ajaxurl,
				data: {
					action: 'delete_user_by_id',
					user_id: userIdToDelete,
					security: wpData.delUserNonce
				},
				success: function(response) {
					// Handle response here
					$('#delete-user-confirmation').foundation('close');
					$(`#ccare__user-row-${userIdToDelete}`).slideUp(300, function() {
						$(this).remove();
						userIdToDelete = null; // Reset the user ID
					});
				}
			});
		}
	});

	// Handle the cancellation
	$('#ccare__delete-user-modal-cancel-btn').click(function() {
		userIdToDelete = null; // Reset the user ID
	});
});
